export default __webpack_public_path__ + "e977d4bd0cbd8a4b13445b7a31c60139.png";